import clsx from 'clsx';
import BaseCheckbox, { BaseCheckboxProps } from 'components/base-checkbox';
import styles from './styles.module.scss';

type SwitchboxProps = Pick<
  BaseCheckboxProps,
  'checked' | 'onChange' | 'label' | 'labelPosition' | 'className'
>;

const Switchbox: React.FC<SwitchboxProps> = (props) => {
  const { className, labelPosition, ...rest } = props;

  return (
    <BaseCheckbox
      {...rest}
      className={clsx(styles.container)}
      inputClassName={styles.input}
      markClassName={clsx(
        styles.slider,
        className && styles[className],
        labelPosition === 'left' && styles.sliderRight,
      )}
      labelClassName={labelPosition === 'left' ? styles.labelLeft : styles.labelRight}
    />
  );
};

export default Switchbox;
